export default __webpack_public_path__ + "static/many arrows-6eebce084278f80701695154ddc380c9.svg";